import { getEndpointPlugin } from "@smithy/middleware-endpoint";
import { Command as $Command } from "@smithy/smithy-client";
import { commonParams } from "../endpoint/EndpointParameters";
import { GetKeyRotationStatus$ } from "../schemas/schemas_0";
export { $Command };
export class GetKeyRotationStatusCommand extends $Command
    .classBuilder()
    .ep(commonParams)
    .m(function (Command, cs, config, o) {
    return [getEndpointPlugin(config, Command.getEndpointParameterInstructions())];
})
    .s("TrentService", "GetKeyRotationStatus", {})
    .n("KMSClient", "GetKeyRotationStatusCommand")
    .sc(GetKeyRotationStatus$)
    .build() {
}
